export default function run($rootScope, Translate, Setting, editableOptions) {
    var cachedLanguage = window.localStorage.getItem('lang');

    if (cachedLanguage) {
        Translate.useLanguage(cachedLanguage)
    } else {
        Translate.getDefaultLanguage().then(function(result) {
            if (result && result.language) {
                Translate.useLanguage(result.language)
            } else {
                Setting.setLanguage('en').then(function() {
                    Translate.useLanguage('en')
                })
            }
        })
    }

    editableOptions.theme = 'bs3';
}
